var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Lottie',{attrs:{"options":_vm.defaultOptions,"height":_vm.$isMobile ? 150 : 250,"width":_vm.$isMobile ? 150 : 250},on:{"animCreated":_vm.handleAnimation}})}
var staticRenderFns = []

export { render, staticRenderFns }